import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="hero">
        <div className="hero-content">
          <div className="message-text">
            <h2>Message from Sarpanch</h2>
            <p>
              Dear villagers,
              <br /><br />
              We warmly welcome you to the official website of Nimgaon Ketki
              Gram Panchayat. Our goal is to promote transparency,
              accountability, and development.
              <br /><br />
              <strong>
                Mr. Pravin Dashrath Dongre
                <br /> Sarpanch, Nimgaon Ketki
              </strong>
            </p>
          </div>

          {/* <div className="sarpanch-photo">
            <img src="/images/sarpanch.jpg" alt="Sarpanch" />
          </div> */}
        </div>
      </section>

      {/* ================= VILLAGE OVERVIEW ================= */}
      <section className="section">
        <div className="container">
          <h3 className="section-title">Nimgaon Ketki Village - Indapur, Pune</h3>

          <div className="info-grid">
            <div><strong>Block / Tehsil:</strong> Indapur</div>
            <div><strong>District:</strong> Pune</div>
            <div><strong>State:</strong> Maharashtra</div>
            <div><strong>Pincode:</strong> 413120</div>
          </div>

          <p className="info-text">
            Nimgaon Ketki is located about 12 km from Indapur and 147 km from Pune.
            As per Census 2011, village code is 557063 and area is 3196 hectares.
          </p>
        </div>
      </section>

      {/* ================= POPULATION ================= */}
      <section className="section light">
        <div className="container">
          <h3 className="section-title">Population (Census 2011)</h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Particulars</th>
                  <th>Total</th>
                  <th>Male</th>
                  <th>Female</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Population</td>
                  <td>12,397</td>
                  <td>6,312</td>
                  <td>6,085</td>
                </tr>
                <tr>
                  <td>Child Population (0–6 yrs)</td>
                  <td>1,449</td>
                  <td>775</td>
                  <td>674</td>
                </tr>
                <tr>
                  <td>Scheduled Castes (SC)</td>
                  <td>1,111</td>
                  <td>568</td>
                  <td>543</td>
                </tr>
                <tr>
                  <td>Scheduled Tribes (ST)</td>
                  <td>22</td>
                  <td>14</td>
                  <td>8</td>
                </tr>
                <tr>
                  <td>Literate Population</td>
                  <td>8,744</td>
                  <td>4,777</td>
                  <td>3,967</td>
                </tr>
                <tr>
                  <td>Illiterate Population</td>
                  <td>3,653</td>
                  <td>1,535</td>
                  <td>2,118</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ================= TRANSPORT ================= */}
      <section className="section">
        <div className="container">
          <h3 className="section-title">Transport & Connectivity</h3>

          <ul className="bullet-list">
            <li>Public Bus Service – Available within village</li>
            <li>Private Bus Service – Available within village</li>
            <li>Railway Station – Within 10+ km distance</li>
          </ul>

          <div className="distance-box">
            <h4>Indapur to Nimgaon Ketki</h4>
            <p>12 km | 30–60 minutes</p>
          </div>

          <div className="distance-box">
            <h4>Pune to Nimgaon Ketki</h4>
            <p>147 km | ~4.2 hours</p>
          </div>
        </div>
      </section>

      {/* ================= NEARBY VILLAGES ================= */}
      <section className="section light">
        <div className="container">
          <h3 className="section-title">Nearby Villages</h3>

          <div className="village-grid">
            {[
              "Nirwangi","Kauthali","Vyahali","Kacharewadi",
              "Gotandi","Varkute Kh","Kati","Jadhavwadi",
              "Reda","Redani","Khorochi"
            ].map((village, index) => (
              <div key={index} className="village-card">
                {village}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FAQ ================= */}
      <section className="section">
        <div className="container">
          <h3 className="section-title">FAQs</h3>

          <div className="faq-item">
            <h4>Where is Nimgaon Ketki located?</h4>
            <p>Located in Indapur Tehsil, Pune district, Maharashtra.</p>
          </div>

          <div className="faq-item">
            <h4>What is the pincode?</h4>
            <p>413120</p>
          </div>

          <div className="faq-item">
            <h4>What is the population?</h4>
            <p>12,397 (Census 2011)</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;